import { create } from "zustand";
import { persist } from "zustand/middleware";

type NavMode = "sidebar" | "topbar";
type ThemeMode = "light" | "dark";
type Accent = "indigo" | "ocean" | "forest" | "rose";

type ThemeState = {
  mode: ThemeMode;
  navMode: NavMode;
  accent: Accent;
  collapsed: boolean;
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
  setNavMode: (mode: NavMode) => void;
  setAccent: (accent: Accent) => void;
  setCollapsed: (collapsed: boolean) => void;
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: "light",
      navMode: "sidebar",
      accent: "indigo",
      collapsed: false,
      setMode: (mode) => set({ mode }),
      toggleMode: () => set({ mode: get().mode === "light" ? "dark" : "light" }),
      setNavMode: (navMode) => set({ navMode }),
      setAccent: (accent) => set({ accent }),
      setCollapsed: (collapsed) => set({ collapsed })
    }),
    { name: "accounting-spa-theme" }
  )
);
